import Vue from 'vue';
import Vuex from 'vuex';
import { datePickerConfig } from './store.js';

Vue.use(Vuex);

const URLs = {
  base: process.env.VUE_APP_USER_BASE_URL,
  lineLogin: process.env.VUE_APP_LINE_LOGIN_URL,
  api: process.env.VUE_APP_API_VERSION,
  getAccessToken: '/login/v1/oauth2/getAccessToken',
  getProfile: process.env.VUE_APP_GET_PROFILE_URL,
  loginApi: '/login/v1/oauth2',
  callback: '/login/callback.html',
  homepage: process.env.VUE_APP_LINE_HOMEPAGE_URL,
  news: '#/news',
  category: '#/category'
};

const routes = {
  todayStats: '/stats',
  latestArticles: '/articles/latest',
  latestArticlesByCategory: '/articles/latestByCategory',
  latestArticlesByPartner: '/articles/latestByPartner',
  recommendArticleByContent: '/articles/recommendation',
  verifiedArticles: '/articles/verified',
  govAnnounces: '/search/govAnnounces',
  getSingleGovAnnounce: '/govAnnounces',
  topTenArticles: '/articles/hottest',
  getSingleArticle: '/articles',
  followingArticles: '/users/followingArticles',
  followingArticleIds: '/users/followingArticleIds',
  searchArticles: '/search/articles',
  partners: '/partners',
  partnersStats: '/partners/stats',
  govPartners: '/govPartners',
  eduPartners: '/eduPartners',
  banner: '/banner/latest',
  classicArticles: '/classicArticles',
  govOption: '/govOptions',
  getAccessTokenByLiff: '/getAccessTokenByLiff',
  feedbackTypes: '/feedbackTypes',
  postFeedbacks: '/users/feedbacks',
  publicReviewers: '/users/publicReviewers'
};

const storageKeys = {
  visited: 'visited',
  lastVisit: 'lastVisit',
  token: 'token',
  displayName: 'displayName',
  pictureUrl: 'pictureUrl',
  id: 'id',
  bannerId: 'bannerId',
  identity: 'identity'
};

export default new Vuex.Store({
  state: {
    URLs: URLs,
    routes: routes,
    channelID: process.env.VUE_APP_CHANNEL_ID,
    storageKeys: storageKeys,
    lang: 'zhtw',
    datePickerConfig: datePickerConfig,
    recaptchaSiteKey: '6LeETL8UAAAAAK6dWfXcfFnyiZKCI6PS-L7MqUEY',
    identity: 'users',
    isLiff: false
  },
  mutations: {
    liffEnable(state) {
      state.isLiff = true;
    }
  }
});
